import {useEffect} from "react";
import TagManager from "grandus-lib/utils/gtag";
import CustomGaEvents from "utils/customGA";

const CustomGaEvent = ({page = "Homepage"}) => {
	useEffect(() => {
		TagManager.push(CustomGaEvents.pageType(page));
	}, [])

	return"";
}
export default CustomGaEvent